import { createSideNavigationLoader } from "@amzn/awsui-app-layout-loader";
import { createWidgetizedSideNavigation, SideNavigationImplementation } from "./implementation";

export const InternalSideNavigation = createWidgetizedSideNavigation(
  createSideNavigationLoader({ Fallback: SideNavigationImplementation }),
);
